import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "my-3 d-flex align-center flex-wrap",
  style: {"gap":"0.5rem"}
}
const _hoisted_2 = {
  class: "d-flex align-center flex-wrap",
  style: {"gap":"1rem"}
}
const _hoisted_3 = { class: "text-body-2" }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = {
  class: "d-flex align-center mb-1",
  style: {"gap":"0.5rem"}
}
const _hoisted_6 = { class: "text-h6 font-weight-bold" }
const _hoisted_7 = { class: "text-caption text-grey" }
const _hoisted_8 = { class: "text-body-2" }
const _hoisted_9 = { class: "text-body-2" }
const _hoisted_10 = { class: "text-body-2" }
const _hoisted_11 = { class: "text-body-2" }
const _hoisted_12 = {
  key: 0,
  class: "text-caption text-grey"
}
const _hoisted_13 = { class: "text-body-2" }
const _hoisted_14 = {
  key: 0,
  class: "text-caption text-grey"
}
const _hoisted_15 = { class: "text-right" }
const _hoisted_16 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_breadcrumbs = _resolveComponent("v-breadcrumbs")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_ai_report_status_chip = _resolveComponent("ai-report-status-chip")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_ai_report_bulk_generate_dialog = _resolveComponent("ai-report-bulk-generate-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createVNode(_component_v_breadcrumbs, {
        class: "px-0",
        items: _ctx.breadcrumbItems
      }, null, 8, ["items"])
    ]),
    _createVNode(_component_page_title, { value: _ctx.pageTitle }, null, 8, ["value"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_btn, {
        color: "primary",
        variant: "flat",
        disabled: _ctx.isFetching || _ctx.isProcessing,
        loading: _ctx.isProcessing,
        onClick: _ctx.openBulkGenerate
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { start: "" }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode("mdi-auto-fix", -1)
            ]))]),
            _: 1
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.isProcessing ? "生成中..." : "一括生成"), 1)
        ]),
        _: 1
      }, 8, ["disabled", "loading", "onClick"]),
      _createVNode(_component_v_btn, {
        color: "primary",
        variant: "outlined",
        disabled: _ctx.isFetching || _ctx.draftCount === 0 || _ctx.isPublishing,
        loading: _ctx.isPublishing,
        onClick: _ctx.bulkPublish
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { start: "" }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode("mdi-publish", -1)
            ]))]),
            _: 1
          }),
          _createTextVNode(" 下書きをすべて公開 (" + _toDisplayString(_ctx.draftCount) + ") ", 1)
        ]),
        _: 1
      }, 8, ["disabled", "loading", "onClick"]),
      _createVNode(_component_v_spacer),
      _createVNode(_component_v_btn, {
        variant: "outlined",
        disabled: _ctx.isFetching || _ctx.isExporting,
        loading: _ctx.isExporting,
        onClick: _ctx.exportCsv
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { start: "" }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode("mdi-file-table-outline", -1)
            ]))]),
            _: 1
          }),
          _cache[4] || (_cache[4] = _createTextVNode(" CSV出力 ", -1))
        ]),
        _: 1
      }, 8, ["disabled", "loading", "onClick"])
    ]),
    (_ctx.activeBatch && _ctx.activeBatch.status === 'processing')
      ? (_openBlock(), _createBlock(_component_v_alert, {
          key: 0,
          variant: "outlined",
          color: "primary",
          icon: "mdi-progress-clock",
          class: "my-2",
          density: "compact"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, " バッチ " + _toDisplayString(_ctx.activeBatch.batchId) + " を生成中... (" + _toDisplayString(_ctx.activeBatch.successCount) + " / " + _toDisplayString(_ctx.activeBatch.totalCount) + ") ", 1),
              _createVNode(_component_v_progress_linear, {
                "model-value": _ctx.batchProgressPercent,
                color: "primary",
                height: "8",
                rounded: "",
                style: {"max-width":"240px"}
              }, null, 8, ["model-value"])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.isFetching)
      ? (_openBlock(), _createBlock(_component_v_progress_linear, {
          key: 1,
          indeterminate: "",
          color: "primary"
        }))
      : _createCommentVNode("", true),
    (_ctx.quarterDetail)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.quarterDetail.classes, (cls) => {
            return (_openBlock(), _createElementBlock("div", {
              key: cls.classId,
              class: "my-4"
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(cls.className), 1),
                _createElementVNode("span", _hoisted_7, "(" + _toDisplayString(cls.ageLabel) + " / " + _toDisplayString(cls.children.length) + "名)", 1)
              ]),
              _createVNode(_component_v_table, null, {
                default: _withCtx(() => [
                  _cache[7] || (_cache[7] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", { style: {"width":"200px"} }, "園児名"),
                      _createElementVNode("th", { style: {"width":"120px"} }, "ステータス"),
                      _createElementVNode("th", { style: {"width":"110px"} }, "生成回数"),
                      _createElementVNode("th", { style: {"width":"120px"} }, "達成項目数"),
                      _createElementVNode("th", { style: {"width":"120px"} }, "経過記録数"),
                      _createElementVNode("th", null, "最終生成"),
                      _createElementVNode("th", null, "最終公開"),
                      _createElementVNode("th", {
                        class: "text-right",
                        style: {"width":"200px"}
                      }, "操作")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cls.children, (c) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: c.childId
                      }, [
                        _createElementVNode("td", null, _toDisplayString(c.lastName) + " " + _toDisplayString(c.firstName), 1),
                        _createElementVNode("td", null, [
                          _createVNode(_component_ai_report_status_chip, {
                            status: c.status
                          }, null, 8, ["status"])
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("span", _hoisted_8, _toDisplayString(c.generationCount) + " 回", 1)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("span", _hoisted_9, _toDisplayString(c.achievedItemCount) + " 個", 1)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("span", _hoisted_10, _toDisplayString(c.progressRecordCount) + " 件", 1)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.formatDateTime(c.lastGeneratedAt)), 1),
                          (c.lastGeneratedBy)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, " by " + _toDisplayString(c.lastGeneratedBy), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.formatDateTime(c.lastPublishedAt)), 1),
                          (c.lastPublishedBy)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, " by " + _toDisplayString(c.lastPublishedBy), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", _hoisted_15, [
                          _createVNode(_component_v_btn, {
                            color: "primary",
                            variant: "outlined",
                            size: "small",
                            to: _ctx.childPath(c.childId)
                          }, {
                            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                              _createTextVNode(" レポートを開く ", -1)
                            ]))]),
                            _: 1
                          }, 8, ["to"])
                        ])
                      ]))
                    }), 128)),
                    (cls.children.length === 0)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_16, [...(_cache[6] || (_cache[6] = [
                          _createElementVNode("td", {
                            colspan: "8",
                            class: "text-center text-grey"
                          }, " 対象クォーターに在籍する園児がいません。 ", -1)
                        ]))]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 2
              }, 1024)
            ]))
          }), 128)),
          (_ctx.quarterDetail.classes.length === 0)
            ? (_openBlock(), _createBlock(_component_v_alert, {
                key: 0,
                type: "info",
                variant: "outlined"
              }, {
                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                  _createTextVNode(" 対象クォーターのクラスがありません。 ", -1)
                ]))]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_ai_report_bulk_generate_dialog, {
      modelValue: _ctx.bulkDialogOpen,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.bulkDialogOpen) = $event)),
      "business-year": _ctx.year,
      quarter: _ctx.quarter,
      "months-label": _ctx.quarterDetail ? _ctx.quarterDetail.monthsLabel : '',
      batch: _ctx.activeBatch,
      "is-starting": _ctx.isStartingBulk,
      onStart: _ctx.startBulkGenerate,
      onClose: _ctx.onBulkDialogClose
    }, null, 8, ["modelValue", "business-year", "quarter", "months-label", "batch", "is-starting", "onStart", "onClose"])
  ]))
}